import React from "react"
import PropTypes from "prop-types"
import ExpiredIcon from "@src/public/icons/expired.inline.svg"
import "../styles.scss"

const Expired = ({ message }) => (
  <div data-testId='download-link-expired-ui' className='center py4 mt3 mb4'>
    <ExpiredIcon className={"expired"}/>
    <h2>Expired</h2>
    <p>{message || "The owner of this content has expired this link."}</p>
  </div>
)

Expired.propTypes = {
  message: PropTypes.string
}

export default Expired
